export const categorie = [
  {
    slug: "kris",
    nome: "Kris — Sfere di Riso",
    descrizione: "Sfere di riso croccanti, cuore filante, tanti gusti.",
    img: "/catalog/cat-kris.jpg",
    prodotti: [
      { nome: "Kris al Ragù", formato: "200 g", prezzo: "€ 2,53", prep: "friggitrice" },
      { nome: "Kris al Pomodoro", formato: "200 g", prezzo: "€ 2,37", prep: "friggitrice" },
      { nome: "Kris alla Carbonara", formato: "200 g", prezzo: "€ 2,74", prep: "friggitrice" },
      { nome: "Kris Amatriciana", formato: "200 g", prezzo: "€ 2,78", prep: "friggitrice" },
      { nome: "Kris alla Gricia", formato: "200 g", prezzo: "€ 2,67", prep: "friggitrice" },
      { nome: "Kris Cacio e Pepe", formato: "200 g", prezzo: "€ 2,38", prep: "friggitrice" },
      { nome: "Kris Porcini e Tartufo", formato: "200 g", prezzo: "€ 2,99", prep: "friggitrice" },
      { nome: "Kris di Pesce", formato: "200 g", prezzo: "€ 2,80", prep: "friggitrice" },
      { nome: "Kris Verza", formato: "200 g", prezzo: "€ 2,70", prep: "friggitrice" },
      { nome: "Kris allo Zafferano", formato: "200 g", prezzo: "€ 2,42", prep: "friggitrice" },
    ],
  },
  {
    slug: "fritti-antipasti",
    nome: "Fritti & Antipasti",
    descrizione: "Sfizi croccanti e antipasti di mare.",
    img: "/catalog/cat-fritti.jpg",
    prodotti: [
      { nome: "Alette di Pollo", formato: "150 g", prezzo: "€ 2,40", prep: "friggitrice" },
      { nome: "Calamari Fritti", formato: "200 g", prezzo: "€ 4,12", prep: "friggitrice" },
      { nome: "Calamari Saporiti", formato: "200 g", prezzo: "€ 5,60", prep: "friggitrice" },
      { nome: "Carciofi Fritti", formato: "150 g", prezzo: "€ 2,85", prep: "friggitrice" },
      { nome: "Nugget di Pollo e Riso", formato: "150 g", prezzo: "€ 2,97", prep: "friggitrice" },
      { nome: "Jalapeños", formato: "150 g", prezzo: "€ 2,70", prep: "friggitrice" },
      { nome: "Polpette di Melanzane", formato: "150 g", prezzo: "€ 3,42", prep: "friggitrice" },
      { nome: "Patatine Fritte", formato: "150 g", prezzo: "€ 1,27", prep: "friggitrice" },
      { nome: "Gamberi Sale Pepe", formato: "150 g", prezzo: "€ 5,45", prep: "friggitrice" },
      { nome: "Carpaccio di Polpo", formato: "150 g", prezzo: "€ 6,37", prep: "freddo" },
      { nome: "Carpaccio di Spada", formato: "150 g", prezzo: "€ 7,66", prep: "freddo" },
      { nome: "Carpaccio di Tonno", formato: "150 g", prezzo: "€ 7,34", prep: "freddo" },
      { nome: "Insalata di Mare Nostrana", formato: "250 g", prezzo: "€ 6,08", prep: "freddo" },
    ],
  },
  {
    slug: "primi",
    nome: "Primi Piatti",
    descrizione: "Paste ripiene, paste al sugo e risotti.",
    img: "/catalog/cat-primi.jpg",
    prodotti: [
      { nome: "Ravioli di Carne e Sugo al Brasato", formato: "270 g", prezzo: "€ 4,26", prep: "microonde" },
      { nome: "Ravioli di Cernia", formato: "270 g", prezzo: "€ 4,40", prep: "microonde" },
      { nome: "Cappellacci al Ragù", formato: "270 g", prezzo: "€ 5,26", prep: "microonde" },
      { nome: "Cappellettoni Burro e Salvia", formato: "270 g", prezzo: "€ 4,23", prep: "microonde" },
      { nome: "Cappelletti Funghi, Speck, Grana e Timo", formato: "270 g", prezzo: "€ 4,86", prep: "microonde" },
      { nome: "Cappelletti in Brodo", formato: "270 g", prezzo: "€ 5,94", prep: "microonde" },
      { nome: "Lasagne alla Bolognese", formato: "350 g", prezzo: "€ 3,15", prep: "microonde" },
      { nome: "Tagliatelle al Ragù", formato: "270 g", prezzo: "€ 4,90", prep: "microonde" },
      { nome: "Linguine allo Scoglio", formato: "270 g", prezzo: "€ 5,46", prep: "microonde" },
      { nome: "Linguine al Pesto", formato: "270 g", prezzo: "€ 3,02", prep: "microonde" },
      { nome: "Spaghetti alle Vongole", formato: "270 g", prezzo: "€ 6,10", prep: "microonde" },
      { nome: "Spaghetti alla Norma", formato: "270 g", prezzo: "€ 2,80", prep: "microonde" },
      { nome: "Penne in Bianco", formato: "200 g", prezzo: "€ 2,10", prep: "microonde" },
      { nome: "Penne all'Arrabbiata", formato: "270 g", prezzo: "€ 3,05", prep: "microonde" },
      { nome: "Mezzemaniche al Pomodoro", formato: "270 g", prezzo: "€ 1,65", prep: "microonde" },
      { nome: "Mezzemaniche alla Carbonara", formato: "270 g", prezzo: "€ 4,03", prep: "microonde" },
      { nome: "Mezzemaniche alla Amatriciana", formato: "270 g", prezzo: "€ 3,69", prep: "microonde" },
      { nome: "Mezzemaniche alla Gricia", formato: "270 g", prezzo: "€ 4,03", prep: "microonde" },
      { nome: "Mezzemaniche Cacio e Pepe", formato: "270 g", prezzo: "€ 3,10", prep: "microonde" },
      { nome: "Risotto Funghi Porcini e Tartufo", formato: "250 g", prezzo: "€ 4,43", prep: "microonde" },
      { nome: "Risotto alla Milanese", formato: "250 g", prezzo: "€ 3,12", prep: "microonde" },
      { nome: "Risotto di Pesce", formato: "250 g", prezzo: "€ 4,35", prep: "microonde" },
      { nome: "Risotto Salsiccia e Asiago", formato: "250 g", prezzo: "€ 2,78", prep: "microonde" },
      { nome: "Riso in Bianco Ribe", formato: "150 g", prezzo: "€ 1,32", prep: "microonde" },
      { nome: "Riso Selenio", formato: "150 g", prezzo: "€ 1,32", prep: "microonde" },
      { nome: "Riso Rosso", formato: "150 g", prezzo: "€ 1,32", prep: "microonde" },
      { nome: "Riso Integrale", formato: "150 g", prezzo: "€ 1,32", prep: "microonde" },
      { nome: "Riso Nero", formato: "150 g", prezzo: "€ 1,32", prep: "microonde" },
    ],
  },
  {
    slug: "secondi",
    nome: "Secondi Piatti",
    descrizione: "Carni, pesce e specialità al forno.",
    img: "/catalog/cat-secondi.jpg",
    prodotti: [
      { nome: "Brasato al Barolo", formato: "300 g", prezzo: "€ 7,09", prep: "microonde" },
      { nome: "Ossobuco alla Milanese", formato: "300 g", prezzo: "€ 10,40", prep: "microonde" },
      { nome: "Guancia di Maiale", formato: "250 g", prezzo: "€ 6,46", prep: "microonde" },
      { nome: "Costine Bbq", formato: "250 g", prezzo: "€ 3,95", prep: "friggitrice" },
      { nome: "Cotoletta alla Valdostana", formato: "250 g", prezzo: "€ 3,70", prep: "friggitrice" },
      { nome: "Cotoletta di Pollo", formato: "250 g", prezzo: "€ 3,23", prep: "friggitrice" },
      { nome: "Petto di Pollo Grigliato", formato: "250 g", prezzo: "€ 4,62", prep: "friggitrice" },
      { nome: "Galletto al Forno", formato: "250 g", prezzo: "€ 4,50", prep: "friggitrice" },
      { nome: "Parmigiana di Melanzane", formato: "300 g", prezzo: "€ 5,78", prep: "microonde" },
      { nome: "Salmone al Vapore", formato: "250 g", prezzo: "€ 6,75", prep: "microonde" },
      { nome: "Sgombro al Forno con Limone", formato: "250 g", prezzo: "€ 6,30", prep: "friggitrice" },
      { nome: "Tonno alle Mandorle", formato: "200 g", prezzo: "€ 6,97", prep: "friggitrice" },
      { nome: "Gamberi alla Vernaccia", formato: "250 g", prezzo: "€ 6,23", prep: "microonde" },
      { nome: "Totano alla Griglia", formato: "250 g", prezzo: "€ 4,94", prep: "friggitrice" },
    ],
  },
  {
    slug: "contorni",
    nome: "Contorni",
    descrizione: "Verdure e patate, pronte da servire.",
    img: "/catalog/cat-contorni.jpg",
    prodotti: [
      { nome: "Patate al Forno", formato: "150 g", prezzo: "€ 1,57", prep: "friggitrice" },
      { nome: "Caponata di Verdure", formato: "150 g", prezzo: "€ 2,37", prep: "microonde" },
      { nome: "Champignon Trifolate", formato: "150 g", prezzo: "€ 2,53", prep: "microonde" },
      { nome: "Melanzane Grigliate", formato: "150 g", prezzo: "€ 2,12", prep: "friggitrice" },
      { nome: "Melanzane Trifolate", formato: "150 g", prezzo: "€ 1,62", prep: "microonde" },
      { nome: "Zucchine Grigliate", formato: "150 g", prezzo: "€ 2,26", prep: "friggitrice" },
      { nome: "Zucchine Trifolate", formato: "150 g", prezzo: "€ 1,62", prep: "microonde" },
      { nome: "Tris di Ortaggi", formato: "150 g", prezzo: "€ 2,32", prep: "friggitrice" },
    ],
  },
  {
    slug: "sughi",
    nome: "Sughi Pronti",
    descrizione: "Sughi nei formati monoporzione da 200 g e placca da 1 kg.",
    img: "/catalog/cat-sughi.jpg",
    prodotti: [
      { nome: "Ragù alla Bolognese", formato: "200 g / 1 kg", prezzo: "€ 2,28 / € 11,41", prep: "microonde" },
      { nome: "Salsa al Pomodoro", formato: "200 g / 1 kg", prezzo: "€ 0,88 / € 4,41", prep: "microonde" },
      { nome: "Sugo alla Amatriciana", formato: "200 g / 1 kg", prezzo: "€ 2,51 / € 12,57", prep: "microonde" },
      { nome: "Sugo alla Carbonara", formato: "200 g / 1 kg", prezzo: "€ 2,91 / € 14,56", prep: "microonde" },
      { nome: "Sugo alla Gricia", formato: "200 g / 1 kg", prezzo: "€ 2,93 / € 14,67", prep: "microonde" },
      { nome: "Sugo allo Scoglio", formato: "200 g / 1 kg", prezzo: "€ 3,22 / € 16,10", prep: "microonde" },
      { nome: "Sugo Cacio e Pepe", formato: "200 g / 1 kg", prezzo: "€ 2,46 / € 12,32", prep: "microonde" },
    ],
  },
  {
    slug: "dolci",
    nome: "Dolci",
    descrizione: "Il finale, rigorosamente senza glutine.",
    img: "/catalog/cat-dolci.jpg",
    prodotti: [
      { nome: "Tiramisù", formato: "100 g", prezzo: "€ 1,95", prep: "freddo" },
      { nome: "Panna Cotta", formato: "100 g", prezzo: "€ 2,51", prep: "freddo" },
      { nome: "Torta Caprese al Limone", formato: "100 g", prezzo: "€ 2,23", prep: "freddo" },
      { nome: "Torta Ricotta e Gocce di Cioccolato", formato: "100 g", prezzo: "€ 2,44", prep: "freddo" },
    ],
  },
];

export const prepLabels = {
  microonde: "Microonde",
  friggitrice: "Friggitrice ad aria",
  freddo: "Servire freddo",
};
